import { Box, Container, Heading, Text, SimpleGrid, VStack, Spinner, Alert, AlertIcon, Select, HStack } from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import TeacherCard from '../components/TeacherCard';

function FindTeacher() {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedInstrument, setSelectedInstrument] = useState('all');

  useEffect(() => {
    async function fetchTeachers() {
      try {
        const { data, error } = await supabase
          .from('public_teachers')
          .select('*');

        if (error) throw error;
        setTeachers(data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    fetchTeachers();
  }, []);

  // Get unique instruments from teachers
  const instruments = ['all', ...new Set(teachers.map(teacher => teacher.specialty))];

  // Filter teachers based on selected instrument
  const filteredTeachers = selectedInstrument === 'all' 
    ? teachers 
    : teachers.filter(teacher => teacher.specialty === selectedInstrument);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minH="60vh">
        <Spinner size="xl" color="teal.500" />
      </Box>
    );
  }

  if (error) {
    return (
      <Container maxW="800px" py={12}>
        <Alert status="error">
          <AlertIcon />
          Error loading teachers: {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Box>
      <Container maxW="1200px" py={12}>
        <VStack spacing={8} align="stretch">
          <Heading as="h1" size="2xl" textAlign="center" color="teal.800">
            Find Your Mock Audition Teacher
          </Heading>
          
          <Text fontSize="lg" textAlign="center">
            Browse our experienced mentors who can help you prepare for your next audition.
          </Text>

          <HStack spacing={4} justify="center" mb={4}>
            <Text fontWeight="medium">Filter by instrument:</Text>
            <Select
              value={selectedInstrument}
              onChange={(e) => setSelectedInstrument(e.target.value)}
              width="200px"
              colorScheme="teal"
            >
              {instruments.map((instrument) => (
                <option key={instrument} value={instrument}>
                  {instrument.charAt(0).toUpperCase() + instrument.slice(1)}
                </option>
              ))}
            </Select>
          </HStack>

          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8} mt={8}>
            {filteredTeachers.map((teacher) => (
              <TeacherCard key={teacher.id} teacher={teacher} />
            ))}
          </SimpleGrid>

          {filteredTeachers.length === 0 && (
            <Text textAlign="center" color="gray.600" mt={8}>
              No teachers found for {selectedInstrument}.
            </Text>
          )}
        </VStack>
      </Container>
    </Box>
  );
}

export default FindTeacher; 